(function() {
	'use strict';
	angular.module('app.shell').directive('edFooterCopyright', edFooterCopyright);

	function edFooterCopyright() {
		var directive = {
			// controller: ['$scope', controller],
			templateUrl: '/app/content/footer/edFooterCopyright.html',
			// restrict: 'EA',
			// scope: {}
		};

		return directive;

		// function controller($scope) {}
	}
})();
